import React, { memo } from 'react';
import EditDropdown from '@components/EditDropdown';
import Icon from '@components/@core/Icon';

const HabitListItem = ({ name, description, editable = false, assigned = 0, dataCy, onSelect = () => {} }) => (
    <div className="lib-todo-habit-schedule" data-cy={dataCy}>
        <div className="d-flex jc-between py-3 border-top">
            <div className="d-flex jc-between w-100">
                <div className="d-flex ai-center">
                    <Icon name="far fa-circle me-3" size={25} color="#676767" />
                    <div>
                        <p className="dsl-b16 mb-1" data-cy="name">
                            {name}
                        </p>
                        <p className="dsl-m12 mb-0" data-cy="description">
                            {description}
                        </p>
                    </div>
                </div>
                <div className="text-right ms-3">
                    <p className="dsl-m12 mb-1">Assigned</p>
                    <p className="dsl-b14 mb-0" data-cy="assigned">
                        {assigned}
                    </p>
                </div>
            </div>
            {editable && (
                <div className="d-h-end desktop-screen edit">
                    <EditDropdown options={['Remove']} dataCy="habitListItemEditDropdown" onChange={onSelect} />
                </div>
            )}
        </div>
    </div>
);

export default memo(HabitListItem);
